import { useEffect, useState } from "react";
import { Camera } from "lucide-react";
import { cn } from "@/lib/utils";
import { getMaterialItemFotoUrl } from "@/lib/api";
import { MATERIAL_ESTADOS, RESERVA_ESTADOS } from "@/lib/material";
import { UserAvatar } from "@/components/UserAvatar";

/** Foto del equipo o un placeholder con icono de cámara. */
export function MaterialFoto({ item, className, iconClassName }) {
  const url = item?.tiene_foto ? getMaterialItemFotoUrl(item.id, item.updated_at) : null;
  const [error, setError] = useState(false);
  useEffect(() => setError(false), [url]);
  if (!url || error) {
    return (
      <div className={cn("flex items-center justify-center bg-gradient-to-br from-muted to-muted/40 text-muted-foreground/60", className)}>
        <Camera className={cn("w-8 h-8", iconClassName)} strokeWidth={1.25} aria-hidden />
      </div>
    );
  }
  return (
    <img
      src={url}
      alt={item.nombre}
      loading="lazy"
      draggable={false}
      onError={() => setError(true)}
      className={cn("object-cover", className)}
    />
  );
}

export function MaterialEstadoBadge({ estado, className }) {
  const cfg = MATERIAL_ESTADOS[estado] || MATERIAL_ESTADOS.disponible;
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium", cfg.badge, className)}>
      <span className={cn("w-1.5 h-1.5 rounded-full", cfg.dot, estado === "retrasado" && "animate-pulse")} />
      {cfg.label}
    </span>
  );
}

export function ReservaEstadoBadge({ reserva, retrasada }) {
  const cfg = retrasada
    ? { label: "Retrasada", badge: MATERIAL_ESTADOS.retrasado.badge }
    : RESERVA_ESTADOS[reserva.estado] || RESERVA_ESTADOS.reservada;
  return <span className={cn("inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium", cfg.badge)}>{cfg.label}</span>;
}

/** Avatar + nombre del usuario (o el email si no está en la lista). */
export function MaterialUser({ email, usersByEmail, size = 20, me, className, nameClassName }) {
  const u = usersByEmail?.[email] || { email, nombre: email?.split("@")[0] };
  return (
    <span className={cn("inline-flex items-center gap-1.5 min-w-0", className)}>
      <UserAvatar user={u} size={size} />
      <span className={cn("truncate", nameClassName)}>{me && email === me ? "Tú" : u.nombre}</span>
    </span>
  );
}
